import { SidePanelConfig } from '@/modules/core/SidePanel/configs/SidePanelConfig';
import { CurrentEstate } from '@/modules/estate/models/CurrentEstate';
import { FlowFormType } from '@/modules/core/form/constants/FlowFormType';

export class BaseFlowFormOptions {
  sidePanelConfig?: SidePanelConfig;
  currentEstate?: CurrentEstate;
  flowFormType?: FlowFormType | string;
  isFlowCompleted?: string;

  constructor(options: Partial<BaseFlowFormOptions> = {}) {
    this.sidePanelConfig = options.sidePanelConfig;
    this.currentEstate = options.currentEstate;
    this.flowFormType = options.flowFormType;
    this.isFlowCompleted = options.isFlowCompleted;
  }
}
